import React from 'react';
import util from "../../../utils/es5Utils";
import _ from "underscore";

const TableView  = function(props){
    if (!props.setRestBlockError) return null;
    const widgets = util.widgetsOfType(props.context, "tableview");
    const newProps = Object.assign({}, props, { widgets });
    const childBlocks = _.values(props.blocks).map((Component, id) => <Component.component { ...newProps } setRestBlockError = {props.setRestBlockError} key={id}/>);
            
    if (childBlocks.length > 0) {
        return (
            <category name='Table' id='tableview' iconclass='category with-icon-paths snap-icon-table_dual'>
                <label text={"Table"}/>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

export default TableView;
